import React, { useState, useEffect } from 'react';

export default function Pagination({ currentPage, totalPages, pageSize, totalItems, onPageChange, onPageSizeChange }) {
  const [inputVal, setInputVal] = useState(String(currentPage));

  useEffect(() => {
    setInputVal(String(currentPage));
  }, [currentPage]);

  const go = (p) => onPageChange(Math.max(1, Math.min(totalPages || 1, p)));

  const commitInput = () => {
    const n = parseInt(inputVal, 10);
    if (!isNaN(n)) go(n);
    else setInputVal(String(currentPage));
  };

  const startItem = totalItems === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const endItem = Math.min(currentPage * pageSize, totalItems);
  const tp = totalPages || 1;

  return (
    <div className="flex items-center justify-between px-4 py-2 border-t border-gray-800 text-xs text-gray-500 select-none flex-wrap gap-2">
      <div className="flex items-center gap-2">
        <span>Rows per page:</span>
        <select
          value={pageSize}
          onChange={e => onPageSizeChange(Number(e.target.value))}
          className="bg-gray-800 border border-gray-700 rounded px-1.5 py-0.5 text-gray-300 focus:outline-none focus:border-blue-500 cursor-pointer"
        >
          {[10, 20, 50, 100].map(s => <option key={s} value={s}>{s}</option>)}
        </select>
        <span className="text-gray-600">{startItem}–{endItem} of {totalItems}</span>
      </div>
      <div className="flex items-center gap-0.5">
        <PgBtn onClick={() => go(1)} disabled={currentPage <= 1} title="First page">«</PgBtn>
        <PgBtn onClick={() => go(currentPage - 1)} disabled={currentPage <= 1} title="Previous page">‹</PgBtn>
        <span className="flex items-center gap-1 px-2 text-gray-400">
          <span>Page</span>
          <input
            type="text"
            value={inputVal}
            onChange={e => setInputVal(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter') commitInput(); }}
            onBlur={commitInput}
            className="w-10 text-center bg-gray-800 border border-gray-700 rounded px-1 py-0.5 text-gray-300 focus:outline-none focus:border-blue-500"
          />
          <span>of {tp}</span>
        </span>
        <PgBtn onClick={() => go(currentPage + 1)} disabled={currentPage >= tp} title="Next page">›</PgBtn>
        <PgBtn onClick={() => go(tp)} disabled={currentPage >= tp} title="Last page">»</PgBtn>
      </div>
    </div>
  );
}

function PgBtn({ onClick, disabled, title, children }) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      title={title}
      className={`w-7 h-7 flex items-center justify-center rounded text-base transition-colors ${
        disabled
          ? 'text-gray-700 cursor-not-allowed'
          : 'text-gray-400 hover:text-gray-200 hover:bg-gray-700 cursor-pointer'
      }`}
    >
      {children}
    </button>
  );
}
